/* eslint-disable */
export default {
    sidebar_my_assessments: "Einladungen",
    sidebar_welcome: "Willkommen",
    sidebar_logout_could_not_logout: "Konnte mich nicht abmelden",
    sidebar_logout_logout_text: "Abmelden",
    sidebar_update_personal_details: "Persönliches Profil",
    sidebar_feature_toggles_menu_item: "Umschaltbare Funktionen",
    sidebar_reports_menu_item: "Berichte"
};
